export default "__VITE_ASSET__BnoX1c2j__"